import { apiEmpleo } from "../../../../../util/ApiEmpleo";

/**
 * Content of the attachment, requested through the API so it carries the JWT
 * (the file itself lives in a private S3 bucket).
 */
export const apiGetCandidateAttachmentContent = async (
  candidateId: string,
  attachmentId: string
): Promise<Blob> => {
  const res = await apiEmpleo.getRawBinary(
    `candidatos/${candidateId}/attachments/${attachmentId}/content`,
    { hideLoadingState: true }
  );

  if (!res) {
    throw new Error("Empty response while fetching the attachment content");
  }

  return new Blob([res.data], { type: res.headers["content-type"] });
};
